{% /* add a container for the columns styling with flexbox without affecting errors div etc. */ %}
<div class="{{ctx.ofPrefix}}columns">
    {% ctx.component.columns.forEach(function(column, index) { %}
    <div class="column column--span-{{column.size}} {% if (column.sizeMobile) { %}column--span-mobile-{{column.sizeMobile}}{% } %} openforms-form-field-container" ref="{{ctx.columnKey}}">
      {{ctx.columnComponents[index]}}
    </div>
    {% }) %}
</div>
